import React, { ReactNode, useState } from 'react'
import { AppProps } from 'next/app'
import '@4tn/tv-npm-player/dist/styles/style.css'
import { initTealium, checkConsent, isClient, sendConsentToTealium, detectAdBlock, setDataLayer } from '../src/utils'
import '../src/styles/reset.scss'
import '../src/styles/error.scss'
import '../src/styles/loaderIcon.scss'
import '../src/styles/secret.scss'
import '../src/styles/global.scss'
import { TalpaConsentData } from '../typings/'
import featureTooling, { FEATURES } from '../src/utils/featureTooling'
import LoaderIcon from '../src/components/LoaderIcon'
import { TPageProps } from '../typings/pageProps'

const EmbedWrapperApp = ({ Component, pageProps }: AppProps<TPageProps>): ReactNode => {
  const [consentData, setConsentData] = useState<TalpaConsentData>()

  React.useEffect(() => {
    if (isClient) {
      const { baitUrl, dataFileUrl, tealiumEnv, countryCode } = pageProps
      detectAdBlock(baitUrl).then((detectedAdBlocker) => {
        setDataLayer({
          app_adsenseid: `adblok:${detectedAdBlocker}`,
        })
      })
      ;(async function (): Promise<void> {
        try {
          let consent = await checkConsent()
          await featureTooling.init(dataFileUrl, countryCode)
          const useVta = featureTooling.isFeatureEnabled(FEATURES.USE_VTA)

          await initTealium(useVta, tealiumEnv)

          if (!consent.tcString) {
            consent = await checkConsent()
          }

          if (window.TN_GDPR_BYPASS && consent.tcString) {
            sendConsentToTealium(consent)
          }

          setConsentData(consent)
        } catch (error) {
          setConsentData({ tcString: '', tcStringCustom: '', hasTalpaConsent: false })
          if (typeof window.newrelic === 'object') window.newrelic.noticeError(error)
        }
      })()
    }
  }, [])

  if (!consentData) return <LoaderIcon />

  return <Component consentData={consentData} {...pageProps} />
}

export default EmbedWrapperApp
